var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2V18H3V19C3 20.7 4.3 22 6 22H18C19.7 22 21 20.7 21 19V2H6ZM19 19C19 19.5 18.5 20 18 20C17.5 20 17 19.5 17 19V18H8V4H19V19Z",
    fill: "#1460AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H9V10H15V5Z",
    fill: "#1460AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H16V7H18V5Z",
    fill: "#1460AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H9V13H18V11Z",
    fill: "#1460AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H9V16H18V14Z",
    fill: "#1460AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H16V10H18V8Z",
    fill: "#1460AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.fc3a57479923303c6d83953745e1276b.svg";
export { ForwardRef as ReactComponent };